/** In-memory TTL cache for risk UI fetches (shared across sticky tabs). */

const DEFAULT_TTL_MS = 5 * 60 * 1000;
const store = new Map();

export function cacheGet(key) {
  const entry = store.get(String(key));
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    store.delete(String(key));
    return null;
  }
  return entry.value;
}

export function cacheSet(key, value, ttlMs = DEFAULT_TTL_MS) {
  const ttl = Math.max(1000, Number(ttlMs) || DEFAULT_TTL_MS);
  store.set(String(key), { value, expiresAt: Date.now() + ttl });
  return value;
}

export function cacheInvalidate(prefixOrKey = null) {
  generation += 1;
  if (prefixOrKey == null || prefixOrKey === '') {
    store.clear();
    return;
  }
  const needle = String(prefixOrKey);
  for (const key of store.keys()) {
    if (key === needle || key.startsWith(`${needle}:`) || key.startsWith(needle)) {
      store.delete(key);
    }
  }
}

const inflight = new Map();
let generation = 0;

export async function cacheFetch(key, loader, ttlMs = DEFAULT_TTL_MS) {
  // Tests mock apiFetch per case — never reuse payloads across tests.
  // CRA: process.env.NODE_ENV (import.meta.env is Vite-only and crashes here).
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    return loader();
  }
  const cacheKey = String(key);
  const seen = generation;
  const hit = cacheGet(cacheKey);
  if (hit != null) {
    return hit;
  }
  if (inflight.has(cacheKey)) {
    return inflight.get(cacheKey);
  }
  const promise = Promise.resolve()
    .then(loader)
    .then((value) => {
      if (seen === generation) {
        cacheSet(cacheKey, value, ttlMs);
      }
      inflight.delete(cacheKey);
      return value;
    })
    .catch((error) => {
      inflight.delete(cacheKey);
      throw error;
    });
  inflight.set(cacheKey, promise);
  return promise;
}

export const QUERY_CACHE_TTL_MS = DEFAULT_TTL_MS;
